export default __webpack_public_path__ + "static/media/cancelRed.1e8eed89.svg";